import React from 'react';

export default function ViewHiddenIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-view-hidden"><path className="primary" d="M15.1 19.34a8 8 0 0 1-8.86-1.68L1.3 12.7a1 1 0 0 1 0-1.42l2.88-2.88 2.8 2.8a5 5 0 0 0 5.73 5.73l2.4 2.4zM8.84 4.6a8 8 0 0 1 8.7 1.74l4.96 4.95a1 1 0 0 1 0 1.42l-2.78 2.78-2.87-2.87a5 5 0 0 0-5.58-5.58L8.85 4.6z"/><path className="secondary" d="M3.3 4.7l16 16a1 1 0 0 0 1.4-1.4l-16-16a1 1 0 0 0-1.4 1.4z"/></svg>
    </Tag>
  )
};
